import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function get_owner_teams(company_party_id, library_party_id = "") {
	return await axios.get(API_URL + "/team/get-owner-team?company_party_id=" + company_party_id + "&library_party_id=" + library_party_id);
}

export async function create_new_team(values) {

    let dataPost = new FormData();

	for (const [key, value] of Object.entries(values)) {
		dataPost.append(key, value);
	}

    return await axios.post(API_URL + "/team/create-new-team", dataPost);
}

export async function update_new_team(values) {

    let dataPost = new FormData();

	for (const [key, value] of Object.entries(values)) {
		dataPost.append(key, value);
	}

    return await axios.post(API_URL + "/team/update-new-team", dataPost);
}